// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t31R","comment":"styles_comment__ZwZ0Z"};